import React, { useEffect, useState } from "react";
import Eventlist from "./EventList";
import AddNewEvent from "./AddNewEvent";
import { getAllEvents, deleteEvent } from "../../../API/Events";
import { toast } from "react-toastify";
import NoData from "../../../components/NoData";
import CommonDelete from "../../../utils/CommonDelet";
import Pagination from "../../../utils/commonPagination";
const Events = () => {
  const [addNewEventModal, setAddNewEventModal] = useState(false);
  const [allEvent, setAllEvent] = useState([]);
  const [editEvent, setEditEvent] = useState({});
  const [deleteEventId, setDeleteEventId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const fetchAllEvent = async (page) => {
    try {
      const response = await getAllEvents(1,page, itemsPerPage);
      if (response?.status) {
        setAllEvent(response?.data);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during fetch:", error);
    }
  };

  useEffect(() => {
    fetchAllEvent(currentPage);
  }, [currentPage, addNewEventModal]);

  const handleEditEvent = (event) => {
    setEditEvent(event);
    setAddNewEventModal(true);
  };

  const addNewEventToggle = () => {
    setAddNewEventModal(!addNewEventModal);
    setEditEvent({});
  };

  const handleDeleteSubmit = async () => {
    try {
      const response = await deleteEvent(deleteEventId);
      if (response?.status) {
        toast.success(response.message);
        fetchAllEvent(currentPage);
        setDeleteEventId("");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during delete request:", error);
    }
  };

  const handleDeleteEvent = (id) => {
    setDeleteEventId(id);
  };
  return (
    <div className="profile-main">
      <div className="event">
        <div className="event_list">
          <h1 className="font-21">Event List</h1>
        </div>
        <button
          type="button"
          className="blackbtn"
          onClick={() => setAddNewEventModal(true)}
        >
          Add New Event
        </button>
      </div>
      {allEvent?.events && allEvent.events.length > 0 ? (
        <div className="event_list">
          <Eventlist
            allEvent={allEvent?.events}
            handleEditEvent={handleEditEvent}
            handleDeleteEvent={handleDeleteEvent}
          />
            <Pagination
            currentPage={currentPage}
            totalNoPages={allEvent?.totalNoPages}
            onNextPage={() => setCurrentPage(currentPage + 1)}
            onPreviousPage={() => setCurrentPage(currentPage - 1)}
          />
        </div>
      ) : (
        <NoData title="There is no event yet" />
      )}
      {addNewEventModal && (
        <AddNewEvent onSetModal={addNewEventToggle} editEvent={editEvent} />
      )}
      {deleteEventId !== "" && (
        <CommonDelete
          onModalClose={setDeleteEventId}
          onSubmit={handleDeleteSubmit}
          title={"Event"}
        />
      )}
    </div>
  );
};

export default Events;
